import { MarketCard } from '../components/MarketCard';

export function RecommendPage({
  marketData,
  activeMarketIndex,
  primaryCategory,
  isEmpty
}) {
  if (isEmpty) {
    return (
      <section className="glass-lg w-full overflow-hidden">
        <div className="p-6 md:p-10 lg:p-10 flex flex-col gap-6">
          <div>
            <p className="uppercase tracking-[0.3em] text-[0.6rem] md:text-[0.65rem] text-text-muted">MARKETS</p>
            <h1 className="text-xl md:text-2xl lg:text-3xl my-1.5">推荐市场</h1>
          </div>
          <div className="p-6 rounded-2xl bg-slate-900/70 border border-slate-600/55 text-slate-300 flex flex-col items-center justify-center text-center py-12">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up text-slate-500 mb-4"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
            <p className="text-lg font-semibold text-white mb-2">暂无推荐市场数据</p>
            <p className="text-sm text-slate-400">请稍后查看，或探索其他市场。</p>
          </div>
        </div>
      </section>
    );
  }

  const activeMarket = marketData[activeMarketIndex];

  return (
    <MarketCard
      market={activeMarket}
      primaryCategory={primaryCategory}
    />
  );
}
